<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class=" mu-d-flex mu-flex-row">

                    <h1 class="mu-mb-00">Application details</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
 
                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>

                </section>
                <section>

                </section>
            </div>

        </div>
    </div>
    <div class="mcc-container--fluid card-padding">

        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Design</li>
                <li>
                    <router-link :to="CONTEXT_PATH + '/design/applications'">Applications</router-link>
                </li>
                <li aria-current="page">Create new</li>
            </ol>
        </nav>
        <div class="mcc-card mu-p-06">
            <div class="mcc-row ">
                <div class="mcc-col mcc-col-12">
                    <form id="formId" novalidate @submit.prevent="saveApplication()">
                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div>

                                <div class="mcc-card">
                                    <div class="mcc-card__header">
                                        <h2 class="mcc-card__title">Details</h2>
                                    </div>
                                    <div class="mcc-card__body">
                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap  mfc-form-input-wrapper--width">
                                                    <label for="name" class="mfc-label--required mu-mb-00">Name</label>
                                                    <input type="text" id="name" name="name" :value="appDto.name" ref="name" required="" placeholder="Name" maxlength="50" :pattern="nameRegex" @change="updateName($event)">
                                                </div>
                                                <div class="mfc-textarea-wrapper mfc-form-input-container input-gap  mfc-form-input-wrapper--width">
                                                    <label for="description">Description</label>
                                                    <textarea id="description" ref="description" name="description" :value="appDto.description" :pattern="descRegex" placeholder="Description" character-count="" maxlength="100" @input="appDto.description = $event.target.value" @change="updateDescription($event)"></textarea>
                                                    <div class="mfc-invalid-feedback"></div><span class="mfc-help-text" v-if="appDto.description"> You have {{100 - appDto.description.length}} characters remaining</span>
                                                    <span class="mfc-help-text" v-else> You have 100 characters remaining</span>
                                                </div>
                                                <TagInput class=" mfc-form-input-wrapper--width" :labels="[]" ref="labels"></TagInput>
                                                <div class="mu-d-flex mu-justify-content-end mu-mt-06">
                                                    <router-link :to="CONTEXT_PATH + '/design/applications'">
                                                        <button type="button" class="mcc-button mcc-button--outline mu-mr-05" id="cancelBtn" title="Cancel">
                                                            <mcc-icon name="cancel" aria-hidden="true"></mcc-icon>
                                                            <span class="mcc-button__label">Cancel</span>
                                                        </button>
                                                    </router-link>
                                                    <button class="mcc-button mcc-button--success " id="saveBtn" title="Save" type="submit">
                                                        <mcc-icon name="save" aria-hidden="true"></mcc-icon>
                                                        <span class="mcc-button__label">Save</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ApplicationAPI from "../../../services/ApplicationAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import TagInput from "../../common/TagInput.vue";
import Utils from "@/script_utils";
import {
    displayErrorMessage, checkFormAndTextareaValidations, handleFormValidation, validationMessages
} from '../../../formvalid';
import { el } from "date-fns/locale";

export default {
    name: "ApplicationCreate",
    components: {
        TagInput
    },
    data() {
        return {
            appDto: {
                description: ""
            },
            updateCall: true,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            helpText: constantMessages.BREADCRUMB_HELP["application.create"],
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            showHelpText: false,
            isDescriptionValid: true,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
    },
    methods: {
        saveApplication() {
            let form = $('#formId')
            let self = this;
            if (!this.isDescriptionValid) {
                return;
            }

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            } 
            this.appDto.labels = this.$refs.labels.value;
            self.updateCall = false;
            ApplicationAPI.saveApplication(this.appDto, "new").then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        }
                        if (k == "labels") {
                            displayErrorMessage($('#tags'), constantMessages.MESSAGES[response.messages[k]])
                            $('#tags')[0].classList.add('ms-is-invalid')
                            $('.mfc-tags-input')[0].classList.add('ms-is-invalid')
                        }
                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    this.$router
                        .push(
                            this.CONTEXT_PATH + "/design/applications/" + response.data.id
                        )
                        .catch(err => {});
                }
            });
        },
        updateDescription(event) {
            let self = this;
            if (event.target.value.length > 100) {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.length"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else if (!event.target.value.match(this.descRegex) && event.target.value != "") {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.invalid"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else {
                self.$refs.description.classList.remove("ms-is-invalid")
                self.isDescriptionValid = true;
            }
            self.appDto.description = event.target.value;
        },

        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.appDto.name = event.target.value;

        },

    }
};
</script>
<style>
.mc-forms__valid-feedback{
    display : none;
}
.mc-forms__invalid-feedback{
    display : none;
}

</style>

